<template>
<CModal @mtdclosemodal="mtdclosemodal" :show="boo_modal" :close-on-backdrop="false" :centered="true" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitle="true" :scrollable="true">
    <div class="container">
        <div class="row px-2">
            <div class="col-md-12 my-1 px-0">
                <div class="d-md-flex flex-wrap text-xs border border-main">
                    <div class="col-xl-3 col-lg-4 col-md-3 bg-main text-white py-2">
                        <div class="px-2">
                            <span class="fw-bold">NOMBRE Y APELLIDOS:</span>
                        </div>
                    </div>
                    <div class="col-xl-5 col-lg-8 col-md-9 col-sm-12 col-xs-12 py-2 border-bottom border-main">
                        <div class="text-center">
                            <span class="fw-bold"> {{ datapatients.patient_name }}
                            </span>
                        </div>
                    </div>
                    <div class="col-xl-1 col-lg-3 col-md-3 bg-main text-white py-2">
                        <div class="px-2">
                            <span class="fw-bold">EDAD: </span>
                        </div>
                    </div>
                    <div class="col-xl-1 col-lg-3 col-md-3 col-sm-12 col-xs-12 py-2 border-bottom border-main">
                        <div class="text-center">
                            <span class="fw-bold"> {{ datapatients.patient_year }}
                            </span>
                        </div>
                    </div>
                    <template v-if="epicrisis.bed_name">
                        <div class="col-xl-1 col-lg-3 col-md-3 bg-main text-white py-2 border-main">
                            <span class="fw-bold">CAMA </span>
                        </div>
                        <div class="col-xl-1 col-lg-3 col-md-3 col-sm-12 col-xs-12 py-2">
                            <span class="fw-bold"> {{ epicrisis.bed_name }}
                            </span>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="d-md-flex flex-wrap mt-2">
            <div class="col-md-6 px-md-1 mt-2">
                <div class="text-xs bg-main rounded">
                    <div class="fw-semibold text-white text-center py-1">
                        DIAGNOSTICO(S) PLANTEADOS AL INGRESO
                    </div>
                </div>
                <div class="mt-1 w-100">
                    <ul class="list-group">
                        <li class="list-group-item text-xs">{{ epicrisis.dx_income}}</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6 px-md-1 mt-2">
                <div class="text-xs bg-main rounded">
                    <div class="fw-semibold text-white text-center py-1">
                        RESUMEN DE LA ANAMNESIS
                    </div>
                </div>
                <div class="col-sm-12 mt-1 mb-1">
                    <textarea disabled placeholder="Escriba un resumen" class="form-control form-control-sm" id="anamnesis" rows="4" style="resize: none" v-model="epicrisis.resumen"></textarea>
                </div>
            </div>
            <div class="col-md-6 px-md-1 mt-2">
                <div class="text-xs bg-main rounded">
                    <div class="fw-semibold text-white text-center py-1">
                        RESUMEN DEL EXAMEN FISICO
                    </div>
                </div>
                <div class="col-sm-12 mt-1 mb-1">
                    <div class="mt-1 w-100">
                        <div v-if="epicrisis.exam_phisical.length > 0">
                            <ul class="list-group text-xs align-left" v-for="(exam, index) in epicrisis.exam_phisical" :key="index">
                                <li class="list-group-item"><b>{{ exam.label }} :</b> {{ exam.value }}</li>
                            </ul>
                        </div>
                        <div v-else>
                            <textarea :disabled="disabledTextArea" placeholder="Escriba el examen fisico" class="form-control form-control-sm" id="exam_phisical" rows="4" style="resize: none" v-model="epicrisis.exam_phisical_text"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 px-md-1 mt-2">
                <div class="text-xs bg-main rounded">
                    <div class="fw-semibold text-white text-center py-1">
                        EXÁMENES AUXILIARES
                    </div>
                </div>
                <div class="col-sm-12 mt-1 mb-1">
                    <textarea disabled placeholder="Escriba el examen auxiliar" class="form-control form-control-sm" id="exam_aux" rows="4" style="resize: none" v-model="epicrisis.exam_aux"></textarea>
                    </div>
                </div>
                <div class="col-md-6 px-md-1 mt-2">
                    <div class="text-xs bg-main rounded">
                        <div class="fw-semibold text-white text-center py-1">
                            PROCEDIMIENTOS DIAGOSTICOS Y/O TERAPEUTICOS
                        </div>
                    </div>
                    <div class="col-sm-12 mt-1 mb-1">
                        <textarea disabled class="form-control form-control-sm" id="proc_dx"
                            rows="4" style="resize: none" v-model="epicrisis.proc_dx"> </textarea>
                    </div>
                </div>
                <div class="col-md-6 px-md-1 mt-2">
                    <div class="text-xs bg-main rounded">
                        <div class="fw-semibold text-white text-center py-1">
                            RESUMEN DE LA EVALUACION Y/O COMPLICACIONES
                        </div>
                    </div>
                    <div class="col-sm-12 mt-1 mb-1">
                        <textarea disabled class="form-control form-control-sm" id="proc_dx" rows="4"
                            style="resize: none" v-model="epicrisis.anamnesis"></textarea>
                    </div>
                </div>
                <div class="col-md-6 px-md-1 mt-2">
                    <div class="text-xs bg-main rounded">
                        <div class="fw-semibold text-white text-center py-1">
                            DIAGNOSTICO(S) FINAL DE EGRESO
                        </div>
                    </div>
                    <div class="col-sm-12 mt-1 mb-1">
                        <textarea disabled class="form-control form-control-sm" id="dx_expense" rows="4"
                            style="resize: none" v-model="epicrisis.dx_final"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <button @click="mtdclosemodal" color="danger" class="btn btn-danger btn-sm">
                <i class="fa fa-times" />&nbsp;Cerrar
            </button>
            &nbsp;
            <button class="btn btn-success btn-sm" @click="mtdSave">
                <i class="fas fa-save" />&nbsp; Guardar
            </button>
            &nbsp;
        </template>
    <SweetAlert :swal="swal" ref="SweetAlert" />
    </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import {
    mapActions
} from 'vuex';
export default {
    name: "c-medico-modal-epicrisis",
    data() {
        return {
            swal: null,
            typeArray: [],
            dataDetail: [],
            dataSop: {},
            dataHospi: {},
            epicrisis: {
                dx_income: "",
                resumen: "",
                exam_phisical: [],
                exam_aux: "",
                procedimientos: "",
                anamnesis: "",
                dx_final: "",
                exam_phisical_text: "",
                bed_name: null,
                medical_act_id: null,
            },
            disabledTextArea: false,
        };
    },
    components: {
        CModal,
        SweetAlert
    },

    props: {
        title: String,
        boo_modal: Boolean,
        datapatients: {
            type: Object,
            default:() => {}
        }
    },
    watch: {
        boo_modal: {
            handler(newVal) {
                    if (newVal) {
                        this.mtdGetData();
                }
            },
            immediate: true,
        },
    },
    computed: {},
    methods: {
        ...mapActions(["get", "post"]),
        mtdclosemodal() {
            this.$emit('mtdclosemodalBed');
        },
        mtdGetData() {
            //buscar por acto medico las hc
            if (this.datapatients.medical_act_id > 0) {
                //let medical_act_id = item.id;
                this.get({
                        url: this.$store.getters.get__url + "/paciente/showMedicalAct/" + this.datapatients.medical_act_id,
                        token: this.$store.getters.get__token,
                    })
                    .then((response) => {
                        this.dataDetail = response.data;
                        this.dataSop = response.data.sop;
                        this.dataHospi = response.data.hosp;
                        this.mtdCompleteData();
                    })
                    .catch((errors) => {
                        console.log(errors);
                    });
            }

        },
        mtdCompleteData() {
            let soporder = this.dataSop.soporder;
            let rxqx = this.dataSop.rxqx;
            let hc_hosp = this.dataHospi ? this.dataHospi.hc : null;
            let dx_income = "";
            let arrayExam = [];
            let arrayExamAux =  [];
            if (soporder) {
                let cie_text = soporder.cie_text;
                let cie = soporder.cie;
                dx_income = cie ? cie.name + " - " + cie.code : cie_text;
                this.epicrisis.resumen = soporder.motive;
            }
            if (rxqx) {
                arrayExam = JSON.parse(rxqx.physical_exams);
                arrayExamAux = JSON.parse(rxqx.auxiliary_exams);
            }
            this.epicrisis.exam_phisical = arrayExam.filter(exam => exam.value !== null);
            this.epicrisis.exam_aux = arrayExamAux
                .filter(exam => exam.value !== null)
                .map(exam => `${exam.label}: ${exam.value}`)
                .join("\n");

            if (hc_hosp) {
                this.epicrisis.resumen = hc_hosp.story;
                this.disabledTextArea = true;
            }
            //completar la informacion
            this.epicrisis.dx_income = dx_income;
            this.epicrisis.anamnesis = this.dataSop.operativereport.findings;
            this.epicrisis.dx_final = this.dataSop.operativereport.operative_diagnosis;
            this.epicrisis.proc_dx = this.dataSop.operativereport.operation;
            this.epicrisis.bed_id = this.dataDetail.hosp ? this.dataDetail.hosp.bed_id : null;
            this.epicrisis.bed_name = this.dataDetail.hosp ? this.dataDetail.hosp.bed_name : null;

        },
        mtdConvertirText: function (){

        },
        mtdSave: function () {
            this.epicrisis.medical_act_id = this.datapatients.medical_act_id;
            this.post({
                    url: this.$store.getters.get__url + "/Sop/saveEpicrisis",
                    token: this.$store.getters.get__token,
                    params: this.epicrisis,
                })
                .then((response) => {
                    this.$refs.SweetAlert.showSuccess(response.message);
                    this.$emit('mtdRegisterAlta');
                    this.mtdHidden();
                })
                .catch((errors) => {
                    console.log(errors);
                });
        },
        mtdHidden: function (){
            this.epicrisis= {
                dx_income: "",
                resumen: "",
                exam_phisical: [],
                exam_aux: "",
                procedimientos: "",
                anamnesis: "",
                dx_final: "",
                exam_phisical_text: "",
                bed_name: null,
                medical_act_id: null,
            };
        }
    }
};
</script>
